import React, { useEffect, useState } from 'react';
import { CardGiftcard } from '@mui/icons-material';
import { SideBarItem } from '@common-components/sidebar/sidebar-items';
import { SidebarLinkButton } from '@common/components/sidebar/sidebar-link-button';
import { backendApi } from '@common-reducers/backend-api/backend-api';
import { isExtensionContext } from '@common-services/detect-context';
import { defaultReferStore, markReferNavSeen, referNavVisible, showReferNewBadge } from './referral-nav-logic';

interface ReferNavItemProps {
  currentActive?: SideBarItem;
  isMinimized: boolean;
}

/**
 * "Refer & earn" entry in the main web navigation (#276). Renders nothing while loading, on error
 * (a non-owner), or while the program is off — the same gate as the share card itself.
 */
export function ReferNavItem({ currentActive, isMinimized }: ReferNavItemProps) {
  const skip = isExtensionContext();
  const { data } = backendApi.useGetMyReferralQuery(undefined, { skip });
  const visible = referNavVisible(data, skip);
  const [showNew, setShowNew] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const store = defaultReferStore();
    markReferNavSeen(store, Date.now());
    setShowNew(showReferNewBadge(store, Date.now()));
  }, [visible]);

  if (!visible) return null;
  return (
    <SidebarLinkButton
      to="/refer?via=nav"
      icon={CardGiftcard}
      titleKey="navigation.referEarn"
      active={SideBarItem.Refer}
      currentActive={currentActive}
      analyticsAction="switch_to_refer"
      testId="refer-view-button"
      badgeKey={showNew ? 'navigation.new' : undefined}
      iconDot={showNew}
      isMinimized={isMinimized}
    />
  );
}
